import { render, staticRenderFns } from "./qaPC.vue?vue&type=template&id=76858ea4&scoped=true"
import script from "./qaPC.vue?vue&type=script&lang=js"
export * from "./qaPC.vue?vue&type=script&lang=js"
import style0 from "./qaPC.vue?vue&type=style&index=0&id=76858ea4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76858ea4",
  null
  
)

export default component.exports